import { useEffect } from "react";

export default function DonationRedirect() {
  useEffect(() => {
    window.location.replace(
      `https://zghazaghxaghrin.mt/donate${window.location.search}`
    );
  }, []);

  return <p>Redirecting…</p>;
}


// ADDED BY NEV FOR XAGHRA REDIRECT